import React from "react";

export const ErrorDisplay = props => (
  <div className="no-offender-results">
    <p className="body-bold">
      <img src="/images/icons/declined.svg" aria-hidden="true" alt="" />
      <span>{props.message}</span>
    </p>
    <p>
      No results were found with the search criteria used. If you believe this
      is an error, please contact our staff for assistance by submitting a
      message using our{" "}
      <a href="https://vadoc.virginia.gov/contact-us/">Contact Form</a>.
    </p>
    <p className="disclaimer">
      Only applications to visit inmates housed in a Virginia Department of
      Corrections facility will be accepted. If you would like to visit an
      inmate in a local or regional jail, please contact that jail about their
      application process.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/ErrorDisplay/ErrorDisplay.js